import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const initialState = () => {
    return {
        items: [],
    };
};

const getters = {
    state: state => state,
    items: state => state.items,
}

const actions = {
    resetState: ({ commit }) => commit('resetState'),
    updateItems: ({ commit }, payload) => commit('setItems', payload),
}

const mutations = {
    resetState(state) {
        Object.assign(state, initialState());
    },
    setItems(state, payload) {
        state.items = payload;
    },
}

const modules = {}

export default {
    namespaced: true,
    state: initialState(),
    getters,
    mutations,
    actions,
    modules
};


// WEBPACK FOOTER //
// ./src/store/modules/locales/index.js